import React from 'react'
import '../../sass/components/_copyright.scss';
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const Copyright = props => (
  <span className="copyright">Copyright &copy; the Broomwagon - {(new Date()).getFullYear()}. All Rights Reserved. Tailor made by <OutboundLink href="https://www.web-hart.com/" target="_blank">WEBhart</OutboundLink>.</span>
)

export default Copyright


// WEBPACK FOOTER //
// ./src/components/Copyright.js